import {LinkButton as GoButton, makeStyles} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import type {Props} from './Button.types'

const useOverrideStyles = makeStyles({
  override: {},
  root: {
    '$override&': {
      height: 56,
      borderRadius: 16,
    },
  },
  label: {
    fontSize: 16,
    flexDirection: 'column',
  },
})

const Button: React.FC<Props> = ({className, children, ...props}) => {
  const {override, ...classes} = useOverrideStyles()

  return (
    <GoButton {...props} className={clsx(override, classes.root, className)}>
      {children}
    </GoButton>
  )
}

export default Button
